import React from "react";
import { espotAPI, imagePrefix } from "../../../../public/constants/constants";
import apiManager from "../../../utils/apiManager";
import "../../../../public/styles/HomeInteriors/homepage/Technology.scss";

class Technology extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Interiors_Technology",
      icons: [],
      desc: [],
      title: "",
      buttonText: "",
    };
  }

  getTechnologyData() {
    apiManager.get(espotAPI + this.state.espotName).then(response => {
      const { data } = response || {};
      this.setState({
        title: data && data.data.title,
        icons: data && data.data.icons,
        desc: data && data.data.descr,
      }).catch(error => {
        this.setState({
          error,
          // isLoading: false,
        });
      });
    });
  }

  componentDidMount() {
    this.getTechnologyData();
  }

  render() {
    return (
      <>
        <div className="tech-page">
          <div>
            <h2 className="tech-head">{this.state.title}</h2>
          </div>
          <div className="tech-body">
            {this.state.icons.map((tech, key) => (
              <div className="tech-card">
                <img className="tech-img" src={imagePrefix + tech} />
                <span className="tech-desc"> {this.state.desc[key]} </span>
              </div>
            ))}
            {/* <img className="tech-img-1" src={techimg1}></img>
                <span className="tech-desc-1"> {this.state.description1} </span>
                <img className="tech-img-2" src={techimg2}></img>
                <div className="tech-desc-2"> {this.state.description2} </div>
                <div className="tech-desc-3"> {this.state.description3} </div>
                <img className="tech-img-3" src={techimg3}></img>
                <div className="tech-desc-4"> {this.state.description4} </div>
                <div className="tech-desc-5"> {this.state.description5} </div> */}
          </div>

          <div>
            {this.state.buttonText != "" ? (
              <button className="tech-button">{this.state.buttonText}</button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default Technology;
